import FindValue from '../components/crud/FindValue'
import AddEnter from '../components/crud/AddEnter'

export const tabsList = [
  { id: 1, title: 'Entries' },
  { id: 2, title: 'Add Entry' },
]

export const tabData = [<FindValue />, <AddEnter />]